// components/PromocionCuponProvider.jsx
import React, { useState, useEffect } from 'react';
import PromocionCuponModal from './modals/PromocionCuponModal';

const PromocionCuponProvider = ({ children }) => {
  const [showPromocion, setShowPromocion] = useState(false);

  useEffect(() => {
    // Verificar si es la primera visita o si ya pasó el tiempo de espera para mostrar de nuevo
    const shouldShowPromo = () => {
      const lastShown = localStorage.getItem('promoLastShown');
      const now = new Date().getTime();
      
      // Si nunca se ha mostrado o han pasado más de 7 días, mostrar
      if (!lastShown || (now - parseInt(lastShown)) > 7 * 24 * 60 * 60 * 1000) {
        localStorage.setItem('promoLastShown', now.toString());
        return true;
      }
      
      return false;
    };
    
    // Pequeño retraso para que la página cargue primero
    const timer = setTimeout(() => {
      if (shouldShowPromo()) {
        setShowPromocion(true);
      }
    }, 2000);
    
    return () => clearTimeout(timer);
  }, []);

  const handleClosePromo = () => {
    setShowPromocion(false);
  };

  return (
    <>
      {children}
      <PromocionCuponModal 
        isOpen={showPromocion} 
        onClose={handleClosePromo} 
      />
    </>
  );
};

export default PromocionCuponProvider;